// ===========================================
// Pricing Configuration Page
// ===========================================
// Admin page for managing pricing matrix with flexible dimensions

import { Box } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import PricingMatrixTab from '../../components/admin/pricing/PricingMatrixTab';
import PricingDimensionSelector from '../../components/admin/pricing/PricingDimensionSelector';
import FlexiblePricingMatrixTab from '../../components/admin/pricing/FlexiblePricingMatrixTab';
import { usePricingConfig, useUpdatePricingConfig } from '../../hooks/usePricing';

// ===========================================
// MAIN COMPONENT
// ===========================================

export default function PricingConfigPage() {
  const { data: configResponse } = usePricingConfig();
  const updateConfig = useUpdatePricingConfig();

  const dimension = configResponse?.dimension ?? 'PROGRAM_LEVEL';

  return (
    <Box>
      <PageHeader
        title="Class Pricing"
        subtitle="Configure pricing matrix"
        breadcrumbs={[
          { label: 'Admin', path: '/admin' },
          { label: 'Class Pricing' },
        ]}
      />

      <PricingDimensionSelector
        currentDimension={dimension}
        onDimensionChange={(dim) => updateConfig.mutate({ dimension: dim })}
        isUpdating={updateConfig.isPending}
      />

      {/* Show legacy matrix for PROGRAM_LEVEL (backward compat), flexible matrix otherwise */}
      {dimension === 'PROGRAM_LEVEL' ? (
        <PricingMatrixTab />
      ) : (
        <FlexiblePricingMatrixTab />
      )}
    </Box>
  );
}
